import React from 'react';
import { Typography, Container, Paper, Divider } from '@mui/material';
import { PageHeader } from '../components/common/PageHeader';
import './ImprintPage.css';

export const ImprintPage: React.FC = () => {
  return (
    <div className="impressum-page">
      <Container maxWidth="md" className="impressum-container">
        <Paper elevation={2} className="impressum-paper">
          {/* Header with back button and title */}
          <PageHeader title="Legal Notice / Impressum" titleVariant="h5" />

          {/* English Section */}
          <Typography 
            variant="h4" 
            component="h2" 
            className="impressum-section-title"
            sx={{ mb: 3, color: 'primary.main', mt: 2 }}
          >
            🇬🇧 English
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Legal Information
          </Typography>
          <Typography paragraph className="impressum-text">
            <strong>CyclingBuddy</strong><br />
            Mario Krone<br />
            Schumannstrasse 53<br />
            60325 Frankfurt am Main<br />
            Germany
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Contact
          </Typography>
          <Typography paragraph className="impressum-text">
            Email: mario@cyclingbuddy.de<br />
            Phone: +49 163 7083452
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            EU Dispute Resolution
          </Typography>
          <Typography paragraph className="impressum-text">
            The European Commission provides a platform for online dispute resolution (ODR): 
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a>
          </Typography>
          <Typography paragraph className="impressum-text">
            Our email address can be found in the contact information above.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Consumer Dispute Resolution
          </Typography>
          <Typography paragraph className="impressum-text">
            We are not willing or obliged to participate in dispute resolution proceedings before a 
            consumer arbitration board.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Liability for Content
          </Typography>
          <Typography paragraph className="impressum-text">
            As a service provider, we are responsible for our own content on these pages in accordance 
            with general laws. However, we are not obligated to monitor transmitted or stored third-party 
            information or to investigate circumstances that indicate illegal activity.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Liability for Links
          </Typography>
          <Typography paragraph className="impressum-text">
            Our website contains links to external third-party websites over whose content we have no 
            control. Therefore, we cannot assume any liability for this external content. The respective 
            provider or operator of the pages is always responsible for the content of the linked pages.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Copyright
          </Typography>
          <Typography paragraph className="impressum-text">
            The content and works created by the site operators on these pages are subject to German 
            copyright law. Duplication, processing, distribution, and any form of commercialization 
            outside the scope of copyright require the written consent of the respective author or creator.
          </Typography>

          <Divider className="impressum-divider" sx={{ my: 4 }} />

          {/* German Section */}
          <Typography 
            variant="h4" 
            component="h2" 
            className="impressum-section-title"
            sx={{ mb: 3, color: 'primary.main' }}
          >
            🇩🇪 Deutsch
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Angaben gemäß § 5 TMG
          </Typography>
          
          <Typography paragraph className="impressum-text">
            <strong>CyclingBuddy</strong><br />
            Mario Krone<br />
            Schumannstrasse 53<br />
            60325 Frankfurt am Main<br />
            Deutschland
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Kontakt
          </Typography>
          <Typography paragraph className="impressum-text">
            E-Mail: mario@cyclingbuddy.de<br />
            Telefon: +49 163 7083452
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </Typography>
          <Typography paragraph className="impressum-text">
            Mario Krone<br />
            Schumannstrasse 53<br />
            60325 Frankfurt am Main
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            EU-Streitschlichtung
          </Typography>
          <Typography paragraph className="impressum-text">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a>
          </Typography>
          <Typography paragraph className="impressum-text">
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </Typography>
          <Typography paragraph className="impressum-text">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Haftung für Inhalte
          </Typography>
          <Typography paragraph className="impressum-text">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
            Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte 
            fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
            rechtswidrige Tätigkeit hinweisen.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Haftung für Links
          </Typography>
          <Typography paragraph className="impressum-text">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
            der Seiten verantwortlich.
          </Typography>

          <Typography 
            variant="h5" 
            component="h3" 
            className="impressum-section-title"
          >
            Urheberrecht
          </Typography>
          <Typography paragraph className="impressum-text">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
            Zustimmung des jeweiligen Autors bzw. Erstellers.
          </Typography>

          <Typography 
            className="impressum-text"
            sx={{
              mt: 4, 
              fontStyle: 'italic', 
              color: 'text.secondary'
            }}
          >
            Last updated: {new Date().toLocaleDateString('en-US')} / Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}
          </Typography>
        </Paper>
      </Container>
    </div>
  );
};
